<template>
  <div class="power">
    <!--头部-->
    <div class="title kf-animate kf-animate-img">
      <div class="title_text">
        <p>核心竞争力</p>
      </div>
    </div>
    <!--内容-->
    <div class="g-box" v-if="list.length">
      <div class="text_box">
        <img class="left" src="@/assets/img/about/power/left.png" />
        <p class="content_text">
          {{ list[0].tips }}
        </p>
        <img class="right" src="@/assets/img/about/power/right.png" />
      </div>
      <img class="img" :src="this.list[0].image" />
    </div>
  </div>
</template>

<script>
import page_mx from "@/mixin/page_mx";
export default {
  mixins: [page_mx],
  data() {
    return {};
  },
  methods: {
    init() {
      this.params = this.$route.params;
      this.getAjax();
    },
    getAjax() {
      this.getList();
    },
  },
};
</script>
<style lang="less" scoped>
.title {
  position: relative;
  margin: 0 auto;
  width: 100%;
  height: 400px;
  background: url(~@/assets/img/about/power/title.png) no-repeat center;
  background-size: cover;
}
.title_text {
  position: absolute;
  top: 98px;
  left: 50%;
  margin-left: -190px;
  width: 380px;
  height: 84px;
  font-size: 60px;
  font-weight: 200;
  color: #ffffff;
  line-height: 84px;
  text-align-last: justify;
  text-align: justify;
}
.g-box {
  transform: translateY(-120px);
}
.text_box {
  position: relative;
  width: 1100px;
  height: 200px;
  background: #ffffff;
  box-shadow: 0px 8px 16px 0px rgba(168, 170, 184, 0.2);
}
.content_text {
  position: absolute;
  top: 64px;
  left: 50%;
  margin-left: -490px;
  width: 980px;
  height: 72px;
  font-size: 16px;
  font-weight: 400;
  color: #292a32;
  line-height: 24px;
}
.left {
  position: absolute;
  left: 20px;
  top: 20px;
}
.right {
  position: absolute;
  top: 160px;
  left: 1020px;
}
.img {
  width: 1080px;
  height: 600px;
  margin: 120px auto 0;
}
</style>
